import React from 'react';
import { WithPermission } from 'Common/Components/WithPermission/index';
import { FEATURE_ANALYTICS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { Description, StyledTitle, Subtitle, SubtitleWrapper, TitleWrapper, TitleAnalyticsrapper, TitleNotisWrapper } from '../styled';

export const KbTitle = () => (
  <StyledTitle>Vulnerability Knowledge Base</StyledTitle>
);

export const Agents = () => (
  <StyledTitle>Runners & Security Scanners</StyledTitle>
);

export const AnalyticsGraphs = () => (
  <WithPermission permission={ FEATURE_ANALYTICS } type={ PERMISSION_TYPES.CREATE }>
    <TitleAnalyticsrapper>
        <StyledTitle>Analytics</StyledTitle>
        <Subtitle>My graphs</Subtitle>
    </TitleAnalyticsrapper>
  </WithPermission>
);

export const NewGraph = () => (
  <WithPermission permission={ FEATURE_ANALYTICS } type={ PERMISSION_TYPES.CREATE }>
    <TitleAnalyticsrapper>
      <StyledTitle>Analytics</StyledTitle>
      <Subtitle>Create new graph</Subtitle>
    </TitleAnalyticsrapper>
  </WithPermission>
);
export const EditGraph = () => (
  <WithPermission permission={ FEATURE_ANALYTICS } type={ PERMISSION_TYPES.CREATE }>
    <TitleAnalyticsrapper>
      <StyledTitle>Analytics</StyledTitle>
      <Subtitle>Graph data</Subtitle>
    </TitleAnalyticsrapper>
  </WithPermission>
);

export const Planner = () => (
  <TitleWrapper>
    <StyledTitle>Planner</StyledTitle>
    <Subtitle>My Projects</Subtitle>
  </TitleWrapper>
);

export const Reports = () => (
  <StyledTitle>Reports</StyledTitle>
);

export const Notifications = () => (
  <TitleNotisWrapper>
    <StyledTitle>Notifications</StyledTitle>
    <SubtitleWrapper>
      <Subtitle>History</Subtitle>
      <Description> - Logged Faraday events</Description>
    </SubtitleWrapper>
  </TitleNotisWrapper>
);

export const NotificationsSettings = () => (
  <TitleWrapper>
    <StyledTitle>Notifications</StyledTitle>
    <SubtitleWrapper>
      <Subtitle>Settings</Subtitle>
      <Description> - Enable / disable event logging and trigger notifications / alerts</Description>
    </SubtitleWrapper>
  </TitleWrapper>
);

export const Scheduler = () => (
  <StyledTitle>Scheduler</StyledTitle>
);

export const Users = () => (
  <StyledTitle>Users</StyledTitle>
);

export const MCP = () => (
  <TitleWrapper>
    <StyledTitle>Connect Faraday via MCP</StyledTitle>
    <SubtitleWrapper>
      <Description>Allow AI clients to interact with your Faraday instance through the Model Context Protocol.</Description>
    </SubtitleWrapper>
  </TitleWrapper>
);
